<template>
  <div v-if="isWorkbench" class="dashboard-container">
    <div class="xiao-nav">
      <div class="xiao-title">销售简报</div>
      <el-select v-model="value" placeholder="请选择" style="width: 16rem;">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="outside">
      <div class="xiao-left" :style="{ width: widthT }">
        <div class="left-t">
          <div class="top-item">
            <div class="i-left">
              <span>新增线索</span>
              <span>{{ newAdd.leadsNum }}</span>
            </div>
            <div class="i-right">
              <img src="../../assets/icons/线索.png" alt="">
            </div>
          </div>
          <div class="top-item">
            <div class="i-left">
              <span>新增客户</span>
              <span>{{ newAdd.customerNum }}</span>
            </div>
            <div class="i-right">
              <img src="../../assets/icons/客户.png" alt="">
            </div>
          </div>
          <div class="top-item">
            <div class="i-left">
              <span>新增合同</span>
              <span>{{ newAdd.contractNum }}</span>
            </div>
            <div class="i-right">
              <img src="../../assets/icons/合同.png" alt="">
            </div>
          </div>
          <div class="top-item">
            <div class="i-left">
              <span>新增回款记录</span>
              <span>{{ newAdd.recordNum }}</span>
            </div>
            <div class="i-right">
              <img src="../../assets/icons/回款记录.png" alt="">
            </div>
          </div>
        </div>
        <div class="left-d">
          <div class="honer">
            <div class="title">个人荣誉榜</div>
            <el-date-picker v-model="value1" type="datetimerange" @blur="bod()" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
          <div class="body">
            <div class="body_nav">
              <span :class="loginType == 'everydayadd' ? 'hoverennd' : ''" @click="everyday">每日跟进数量排名</span>
              <span :class="loginType == 'communicateadd' ? 'hoverennd' : ''" @click="communicate">通话时长</span>
              <span :class="loginType == 'signadd' ? 'hoverennd' : ''" @click="sign">已签约客户金额</span>
            </div>
            <div v-if="Allhonor.length">
              <div class="body_body" v-if="types == 1">
                <div class="bodynone" v-if="Allhonor[0].creater_name">
                  <div class="b-i">
                    <div>
                      <img class="icon_img" src="../../assets/icons/第一.png" alt />
                      <img class="avatar" :src="Allhonor[0].avatar" alt v-if="Allhonor[0].avatar" />
                      <span v-if="Allhonor[0].creater">
                        {{ Allhonor[0].creater_name }}&nbsp;&nbsp;
                      </span>
                    </div>
                    <span>
                      <span>累计跟进数量</span>
                      <span v-if="Allhonor[0].total" v-show="Allhonor[0].total" style="
                                color: #49B372;
                                margin-left: 1rem;
                                font-size: 3.6rem;
                              " :class="{ price: types === 3 }">{{ Allhonor[0].total }}</span>
                    </span>
                  </div>
                </div>
                <div class="bodynone" v-if="Allhonor[1].creater_name">
                  <div class="b-i">
                    <div>
                      <img class="icon_img" src="../../assets/icons/第二.png" alt />
                      <img class="avatar" :src="Allhonor[1].avatar" alt v-if="Allhonor[1].avatar" />
                      <span v-if="Allhonor[1].creater">
                        {{ Allhonor[1].creater_name }}
                        &nbsp;&nbsp;
                      </span>
                    </div>
                    <span>
                      <span>累计跟进数量</span>
                      <span v-if="Allhonor[1].creater_name" v-show="Allhonor[1].total" style="
                                color: #49B372;
                                margin-left: 1rem;
                                font-size: 3.6rem;
                              " :class="{ price: types === 3 }">{{ Allhonor[1].total }}</span>
                    </span>
                  </div>
                </div>
                <div class="bodynone" v-if="Allhonor[2].creater_name">
                  <div class="b-i">
                    <div>
                      <img class="icon_img" src="../../assets/icons/第三.png" alt />
                      <img class="avatar" :src="Allhonor[2].avatar" alt v-if="Allhonor[2].avatar" />
                      <span v-if="Allhonor[2].creater">
                        {{ Allhonor[2].creater_name }}
                        &nbsp;&nbsp;
                      </span>
                    </div>
                    <span>
                      <span>累计跟进数量</span>
                      <span v-if="Allhonor[2].total" v-show="Allhonor[2].total" style="
                                color: #49B372;
                                margin-left: 1rem;
                                font-size: 3.6rem;
                              " :class="{ price: types === 3 }">{{ Allhonor[2].total }}</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="body_body" v-if="types == 2">
                <div class="bodynone" v-if="Allhonor[0].creater_name">
                  <div>
                    <svg t="1625728561849" class="icon iconfont iconfirst" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1232" width="34" height="34">
                      <path
                        d="M673.5104 0v316.16l173.952-145.7664V0h-173.952zM151.9616 170.368l173.9264 145.792V0H151.9616v170.368z m248.32 208.2816l74.6496 62.72c13.6448 13.5424 35.584 13.5424 49.2288 0l74.6752-62.72V0h-198.8352v378.624h0.2816z"
                        fill="#FE8781" p-id="1233"></path>
                      <path
                        d="M880.2816 514.6368c-55.7568-41.3952-78.3872-96.8448-67.9424-165.8368 10.4192-69.2736-18.688-98.3808-87.0656-88.064-68.4288 10.5216-123.1872-12.544-164.224-68.7616-41.0624-56.2176-82.0992-56.2176-123.1872 0-41.088 56.2176-95.8208 79.3088-164.2496 68.736-68.4288-10.5216-97.536 18.8416-87.0656 88.064 10.4448 69.248-12.2112 124.4672-67.9424 165.888-55.7312 41.3696-55.7312 83.0464 0 124.416 55.7568 41.4208 78.3872 96.8704 67.9424 165.888-10.4448 69.248 18.6368 98.3296 87.0656 88.064 68.4288-10.496 123.1872 12.544 164.2496 68.7616 41.0368 56.192 82.0992 56.192 123.1872 0 41.0368-56.2176 95.7952-79.3088 164.224-68.7616 68.4288 10.5216 97.536-18.816 87.0656-88.064-10.4448-69.2992 12.1856-124.4672 67.9424-165.888 55.7568-41.3696 55.7568-83.0464 0-124.416z"
                        fill="#FDE51B" p-id="1234"></path>
                      <path
                        d="M247.7312 579.1232c0 144.7936 116.096 262.2208 259.2768 262.2208 143.2064 0 259.2768-117.376 259.328-262.1696v-0.0512c0-144.8192-116.096-262.2208-259.3024-262.2208-143.1808 0-259.2512 117.4016-259.3024 262.1952v0.0256z"
                        fill="#FDBA36" p-id="1235"></path>
                      <path
                        d="M532.1728 435.7632v286.72h-43.3664v-234.112c-17.5616 16.5888-39.3728 28.672-65.3568 36.1472v-43.3664c14.208-3.84 27.904-9.4976 40.6528-16.896a171.0336 171.0336 0 0 0 35.0208-28.4928h33.024z"
                        fill="#FFFFFF" p-id="1236"></path>
                    </svg>
                    <img class="avatar" :src="Allhonor[0].avatar" alt v-if="Allhonor[0].avatar" />
                    <div>
                      <span v-if="Allhonor[0].creater">
                        {{ Allhonor[0].creater_name }}&nbsp;&nbsp;
                      </span>
                      <span>
                        <span>累计通话时长</span>
                        <span v-if="Allhonor[0].total" v-show="Allhonor[0].total" style="
                                color: #F96460;
                                margin-left: 8px;
                                font-size: 24px;
                              " :class="{ price: types === 3 }">{{ Allhonor[0].total }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="bodynone" v-if="Allhonor[1].creater_name">
                  <div>
                    <svg t="1625728697123" class="icon iconfont" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1377" width="34" height="34">
                      <path
                        d="M673.7152 0.384v316.16l173.952-145.7408V0.384h-173.952zM152.1664 170.752l173.9264 145.8176V0.4096H152.1664V170.752z m248.32 208.2816l74.6496 62.72c13.6704 13.568 35.584 13.568 49.2544 0l74.6496-62.72V0.4096h-198.8352v378.624h0.3072z"
                        fill="#FE8781" p-id="1378"></path>
                      <path
                        d="M880.4864 515.0464c-55.7568-41.3952-78.3872-96.8448-67.9168-165.8624 10.4192-69.2736-18.688-98.3808-87.0912-88.064-68.4288 10.5216-123.1872-12.544-164.224-68.736-41.0624-56.2176-82.0992-56.2176-123.1872 0-41.088 56.2176-95.7952 79.3088-164.224 68.736-68.4288-10.5472-97.536 18.8416-87.0912 88.064 10.4448 69.248-12.2112 124.4672-67.9168 165.8624-55.7568 41.3952-55.7568 83.0464 0 124.4416 55.7312 41.3952 78.3616 96.8448 67.9168 165.8368-10.4448 69.2736 18.6624 98.3552 87.0912 88.0896 68.4288-10.496 123.1616 12.544 164.224 68.7616 41.0624 56.192 82.0992 56.192 123.1872 0 41.0368-56.2176 95.7952-79.3088 164.224-68.7616 68.4288 10.5472 97.536-18.816 87.0912-88.064-10.4704-69.2736 12.16-124.4672 67.9168-165.8624s55.7568-83.0464 0-124.4416z"
                        fill="#E4E4E4" p-id="1379"></path>
                      <path
                        d="M247.9616 579.5328c0 144.7936 116.0704 262.2208 259.2512 262.2208 143.2064 0 259.2768-117.4016 259.328-262.1952v-0.0256c0-144.8448-116.096-262.2464-259.2768-262.2464-143.2064 0-259.2768 117.4016-259.328 262.1952v0.0512z"
                        fill="#C0C0CB" p-id="1380"></path>
                      <path
                        d="M578.8928 435.9936c17.3056 16.0512 25.9328 36.6848 25.9328 61.8496 0 24.3456-9.3184 46.976-27.8784 67.84-11.1616 11.52-30.8736 26.9312-58.9824 46.208-30.5152 20.3264-48.7936 38.4-54.912 54.1952h142.1568v38.5536h-195.9168c0-28.6208 9.4208-53.6832 28.288-75.0848 9.8048-11.776 31.1808-29.184 64.0768-52.224 19.3792-13.9008 32.9216-24.8832 40.6016-32.9216 13.056-14.72 19.5328-30.3872 19.5328-46.976 0-16.0512-4.352-28.1088-13.1584-36.1472-8.7552-8.0128-21.5552-12.032-38.6304-12.032-18.0224 0-31.5392 6.144-40.576 18.4576-9.2928 11.776-14.336 29.312-15.1296 52.608H410.88c0.5376-32.128 9.7024-57.8304 27.4944-77.1072 18.048-20.608 42.4704-30.8992 73.2672-30.8992 27.5712 0 49.9968 7.8848 67.2512 23.68z"
                        fill="#FFFFFF" p-id="1381"></path>
                    </svg>

                    <img class="avatar" :src="Allhonor[1].avatar" alt v-if="Allhonor[1].avatar" />
                    <div>
                      <span v-if="Allhonor[1].creater">
                        {{ Allhonor[1].creater_name }}
                        &nbsp;&nbsp;
                      </span>
                      <span>
                        <span>累计通话时长</span>
                        <span v-if="Allhonor[1].creater_name" v-show="Allhonor[1].total" style="
                                color: #F96460;
                                margin-left: 8px;
                                font-size: 24px;
                              " :class="{ price: types === 3 }">{{ Allhonor[1].total }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="bodynone" v-if="Allhonor[2].creater">
                  <div>
                    <svg t="1625728804733" class="icon iconfont" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1568" width="34" height="34">
                      <path
                        d="M673.7152 0.384v316.16l173.952-145.7408V0.384h-173.952zM152.1664 170.752l173.9264 145.8176V0.4096H152.1664V170.752z m248.32 208.2816l74.6496 62.72c13.6704 13.568 35.584 13.568 49.2544 0l74.6496-62.72V0.4096h-198.8352v378.624h0.3072z"
                        fill="#FE8781" p-id="1569"></path>
                      <path
                        d="M880.4864 515.0464c-55.7568-41.3952-78.3872-96.8448-67.9168-165.8624 10.4192-69.2736-18.688-98.3808-87.0912-88.064-68.4288 10.5216-123.1872-12.544-164.224-68.736-41.0624-56.2176-82.0992-56.2176-123.1872 0-41.088 56.2176-95.7952 79.3088-164.224 68.736-68.4288-10.5472-97.536 18.8416-87.0912 88.064 10.4448 69.248-12.2112 124.4672-67.9168 165.8624-55.7568 41.3952-55.7568 83.0464 0 124.4416 55.7312 41.3952 78.3616 96.8448 67.9168 165.8368-10.4448 69.2736 18.6624 98.3552 87.0912 88.0896 68.4288-10.496 123.1616 12.544 164.224 68.7616 41.0624 56.192 82.0992 56.192 123.1872 0 41.0368-56.2176 95.7952-79.3088 164.224-68.7616 68.4288 10.5472 97.536-18.816 87.0912-88.064-10.4704-69.2736 12.16-124.4672 67.9168-165.8624s55.7568-83.0464 0-124.4416z"
                        fill="#E4E4E4" p-id="1570"></path>
                      <path
                        d="M247.9616 579.5328c0 144.7936 116.0704 262.2208 259.2512 262.2208 143.2064 0 259.2768-117.4016 259.328-262.1952v-0.0256c0-144.8448-116.096-262.2464-259.2768-262.2464-143.2064 0-259.2768 117.4016-259.328 262.1952v0.0512z"
                        fill="#C0C0CB" p-id="1571"></path>
                      <path
                        d="M578.8928 435.9936c17.3056 16.0512 25.9328 36.6848 25.9328 61.8496 0 24.3456-9.3184 46.976-27.8784 67.84-11.1616 11.52-30.8736 26.9312-58.9824 46.208-30.5152 20.3264-48.7936 38.4-54.912 54.1952h142.1568v38.5536h-195.9168c0-28.6208 9.4208-53.6832 28.288-75.0848 9.8048-11.776 31.1808-29.184 64.0768-52.224 19.3792-13.9008 32.9216-24.8832 40.6016-32.9216 13.056-14.72 19.5328-30.3872 19.5328-46.976 0-16.0512-4.352-28.1088-13.1584-36.1472-8.7552-8.0128-21.5552-12.032-38.6304-12.032-18.0224 0-31.5392 6.144-40.576 18.4576-9.2928 11.776-14.336 29.312-15.1296 52.608H410.88c0.5376-32.128 9.7024-57.8304 27.4944-77.1072 18.048-20.608 42.4704-30.8992 73.2672-30.8992 27.5712 0 49.9968 7.8848 67.2512 23.68z"
                        fill="#FFFFFF" p-id="1572"></path>
                    </svg>
                    <img class="avatar" :src="Allhonor[2].avatar" alt v-if="Allhonor[2].avatar" />
                    <div>
                      <span v-if="Allhonor[2].creater">
                        {{ Allhonor[2].creater_name }}
                        &nbsp;&nbsp;
                      </span>
                      <span>
                        <span>累计通话时长</span>
                        <span v-if="Allhonor[2].total" v-show="Allhonor[2].total" style="
                                color: #F96460;
                                margin-left: 8px;
                                font-size: 24px;
                              " :class="{ price: types === 3 }">{{ Allhonor[2].total }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="body_body" v-if="types == 3">
                <div class="bodynone" v-if="Allhonor[0].creater">
                  <div>
                    <svg t="1625728561849" class="icon iconfont iconfirst" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1232" width="34" height="34">
                      <path
                        d="M673.5104 0v316.16l173.952-145.7664V0h-173.952zM151.9616 170.368l173.9264 145.792V0H151.9616v170.368z m248.32 208.2816l74.6496 62.72c13.6448 13.5424 35.584 13.5424 49.2288 0l74.6752-62.72V0h-198.8352v378.624h0.2816z"
                        fill="#FE8781" p-id="1233"></path>
                      <path
                        d="M880.2816 514.6368c-55.7568-41.3952-78.3872-96.8448-67.9424-165.8368 10.4192-69.2736-18.688-98.3808-87.0656-88.064-68.4288 10.5216-123.1872-12.544-164.224-68.7616-41.0624-56.2176-82.0992-56.2176-123.1872 0-41.088 56.2176-95.8208 79.3088-164.2496 68.736-68.4288-10.5216-97.536 18.8416-87.0656 88.064 10.4448 69.248-12.2112 124.4672-67.9424 165.888-55.7312 41.3696-55.7312 83.0464 0 124.416 55.7568 41.4208 78.3872 96.8704 67.9424 165.888-10.4448 69.248 18.6368 98.3296 87.0656 88.064 68.4288-10.496 123.1872 12.544 164.2496 68.7616 41.0368 56.192 82.0992 56.192 123.1872 0 41.0368-56.2176 95.7952-79.3088 164.224-68.7616 68.4288 10.5216 97.536-18.816 87.0656-88.064-10.4448-69.2992 12.1856-124.4672 67.9424-165.888 55.7568-41.3696 55.7568-83.0464 0-124.416z"
                        fill="#FDE51B" p-id="1234"></path>
                      <path
                        d="M247.7312 579.1232c0 144.7936 116.096 262.2208 259.2768 262.2208 143.2064 0 259.2768-117.376 259.328-262.1696v-0.0512c0-144.8192-116.096-262.2208-259.3024-262.2208-143.1808 0-259.2512 117.4016-259.3024 262.1952v0.0256z"
                        fill="#FDBA36" p-id="1235"></path>
                      <path
                        d="M532.1728 435.7632v286.72h-43.3664v-234.112c-17.5616 16.5888-39.3728 28.672-65.3568 36.1472v-43.3664c14.208-3.84 27.904-9.4976 40.6528-16.896a171.0336 171.0336 0 0 0 35.0208-28.4928h33.024z"
                        fill="#FFFFFF" p-id="1236"></path>
                    </svg>
                    <img :src="Allhonor[0].avatar" alt v-if="Allhonor[0].avatar" class="avatar" />
                    <div>
                      <span v-if="Allhonor[0].creater">
                        {{ Allhonor[0].creater_name }}&nbsp;&nbsp;
                      </span>
                      <span>
                        <span>累计金额</span>
                        <span v-if="Allhonor[0].total" v-show="Allhonor[0].total" style="
                                color: #F96460;
                                margin-left: 8px;
                                font-size: 24px;
                              " :class="{ price: types === 3 }">{{ Allhonor[0].total }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="bodynone" v-if="Allhonor[1].creater">
                  <div>
                    <svg t="1625728697123" class="icon iconfont" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1377" width="34" height="34">
                      <path
                        d="M673.7152 0.384v316.16l173.952-145.7408V0.384h-173.952zM152.1664 170.752l173.9264 145.8176V0.4096H152.1664V170.752z m248.32 208.2816l74.6496 62.72c13.6704 13.568 35.584 13.568 49.2544 0l74.6496-62.72V0.4096h-198.8352v378.624h0.3072z"
                        fill="#FE8781" p-id="1378"></path>
                      <path
                        d="M880.4864 515.0464c-55.7568-41.3952-78.3872-96.8448-67.9168-165.8624 10.4192-69.2736-18.688-98.3808-87.0912-88.064-68.4288 10.5216-123.1872-12.544-164.224-68.736-41.0624-56.2176-82.0992-56.2176-123.1872 0-41.088 56.2176-95.7952 79.3088-164.224 68.736-68.4288-10.5472-97.536 18.8416-87.0912 88.064 10.4448 69.248-12.2112 124.4672-67.9168 165.8624-55.7568 41.3952-55.7568 83.0464 0 124.4416 55.7312 41.3952 78.3616 96.8448 67.9168 165.8368-10.4448 69.2736 18.6624 98.3552 87.0912 88.0896 68.4288-10.496 123.1616 12.544 164.224 68.7616 41.0624 56.192 82.0992 56.192 123.1872 0 41.0368-56.2176 95.7952-79.3088 164.224-68.7616 68.4288 10.5472 97.536-18.816 87.0912-88.064-10.4704-69.2736 12.16-124.4672 67.9168-165.8624s55.7568-83.0464 0-124.4416z"
                        fill="#E4E4E4" p-id="1379"></path>
                      <path
                        d="M247.9616 579.5328c0 144.7936 116.0704 262.2208 259.2512 262.2208 143.2064 0 259.2768-117.4016 259.328-262.1952v-0.0256c0-144.8448-116.096-262.2464-259.2768-262.2464-143.2064 0-259.2768 117.4016-259.328 262.1952v0.0512z"
                        fill="#C0C0CB" p-id="1380"></path>
                      <path
                        d="M578.8928 435.9936c17.3056 16.0512 25.9328 36.6848 25.9328 61.8496 0 24.3456-9.3184 46.976-27.8784 67.84-11.1616 11.52-30.8736 26.9312-58.9824 46.208-30.5152 20.3264-48.7936 38.4-54.912 54.1952h142.1568v38.5536h-195.9168c0-28.6208 9.4208-53.6832 28.288-75.0848 9.8048-11.776 31.1808-29.184 64.0768-52.224 19.3792-13.9008 32.9216-24.8832 40.6016-32.9216 13.056-14.72 19.5328-30.3872 19.5328-46.976 0-16.0512-4.352-28.1088-13.1584-36.1472-8.7552-8.0128-21.5552-12.032-38.6304-12.032-18.0224 0-31.5392 6.144-40.576 18.4576-9.2928 11.776-14.336 29.312-15.1296 52.608H410.88c0.5376-32.128 9.7024-57.8304 27.4944-77.1072 18.048-20.608 42.4704-30.8992 73.2672-30.8992 27.5712 0 49.9968 7.8848 67.2512 23.68z"
                        fill="#FFFFFF" p-id="1381"></path>
                    </svg>
                    <img class="avatar" :src="Allhonor[1].avatar" alt v-if="Allhonor[1].avatar" />
                    <div>
                      <span v-if="Allhonor[1].creater">
                        {{ Allhonor[1].creater_name }}
                        &nbsp;&nbsp;
                      </span>
                      <span>
                        <span>累计金额</span>
                        <span v-if="Allhonor[1].creater_name" v-show="Allhonor[1].total" style="
                                color: #F96460;
                                margin-left: 8px;
                                font-size: 24px;
                              " :class="{ price: types === 3 }">{{ Allhonor[1].total }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="bodynone" v-if="Allhonor[2].creater">
                  <div>
                    <svg t="1625728804733" class="icon iconfont" viewBox="0 0 1024 1024" version="1.1"
                      xmlns="http://www.w3.org/2000/svg" p-id="1568" width="34" height="34">
                      <path
                        d="M673.7152 0.384v316.16l173.952-145.7408V0.384h-173.952zM152.1664 170.752l173.9264 145.8176V0.4096H152.1664V170.752z m248.32 208.2816l74.6496 62.72c13.6704 13.568 35.584 13.568 49.2544 0l74.6496-62.72V0.4096h-198.8352v378.624h0.3072z"
                        fill="#FE8781" p-id="1569"></path>
                      <path
                        d="M880.4864 515.0464c-55.7568-41.3952-78.3872-96.8448-67.9168-165.8624 10.4192-69.2736-18.688-98.3808-87.0912-88.064-68.4288 10.5216-123.1872-12.544-164.224-68.736-41.0624-56.2176-82.0992-56.2176-123.1872 0-41.088 56.2176-95.7952 79.3088-164.224 68.736-68.4288-10.5472-97.536 18.8416-87.0912 88.064 10.4448 69.248-12.2112 124.4672-67.9168 165.8624-55.7568 41.3952-55.7568 83.0464 0 124.4416 55.7312 41.3952 78.3616 96.8448 67.9168 165.8368-10.4448 69.2736 18.6624 98.3552 87.0912 88.0896 68.4288-10.496 123.1616 12.544 164.224 68.7616 41.0624 56.192 82.0992 56.192 123.1872 0 41.0368-56.2176 95.7952-79.3088 164.224-68.7616 68.4288 10.5472 97.536-18.816 87.0912-88.064-10.4704-69.2736 12.16-124.4672 67.9168-165.8624s55.7568-83.0464 0-124.4416z"
                        fill="#E4E4E4" p-id="1570"></path>
                      <path
                        d="M247.9616 579.5328c0 144.7936 116.0704 262.2208 259.2512 262.2208 143.2064 0 259.2768-117.4016 259.328-262.1952v-0.0256c0-144.8448-116.096-262.2464-259.2768-262.2464-143.2064 0-259.2768 117.4016-259.328 262.1952v0.0512z"
                        fill="#C0C0CB" p-id="1571"></path>
                      <path
                        d="M578.8928 435.9936c17.3056 16.0512 25.9328 36.6848 25.9328 61.8496 0 24.3456-9.3184 46.976-27.8784 67.84-11.1616 11.52-30.8736 26.9312-58.9824 46.208-30.5152 20.3264-48.7936 38.4-54.912 54.1952h142.1568v38.5536h-195.9168c0-28.6208 9.4208-53.6832 28.288-75.0848 9.8048-11.776 31.1808-29.184 64.0768-52.224 19.3792-13.9008 32.9216-24.8832 40.6016-32.9216 13.056-14.72 19.5328-30.3872 19.5328-46.976 0-16.0512-4.352-28.1088-13.1584-36.1472-8.7552-8.0128-21.5552-12.032-38.6304-12.032-18.0224 0-31.5392 6.144-40.576 18.4576-9.2928 11.776-14.336 29.312-15.1296 52.608H410.88c0.5376-32.128 9.7024-57.8304 27.4944-77.1072 18.048-20.608 42.4704-30.8992 73.2672-30.8992 27.5712 0 49.9968 7.8848 67.2512 23.68z"
                        fill="#FFFFFF" p-id="1572"></path>
                    </svg>
                    <img class="avatar" :src="Allhonor[2].avatar" alt v-if="Allhonor[2].avatar" />
                    <div>
                      <span v-if="Allhonor[2].creater">
                        {{ Allhonor[2].creater_name }}
                        &nbsp;&nbsp;
                      </span>
                      <span>
                        <span>累计金额</span>
                        <span v-if="Allhonor[2].total" v-show="Allhonor[2].total" style="
                                color: #F96460;
                                margin-left: 8px;
                                font-size: 24px;
                              " :class="{ price: types === 3 }">{{ Allhonor[2].total }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="xiao-right" :style="{ width: widthT }">
        <div class="right-t">
          <div class="top-item">
            <div class="i-left">
              <span>新增联系人</span>
              <span>{{ newAdd.contactsNum }}</span>
            </div>
            <div class="i-right">
              <img src="../../assets/icons/联系人.png" alt="">
            </div>
          </div>
          <div class="top-item">
            <div class="i-left">
              <span>新增商机</span>
              <span>{{ newAdd.businessNum }}</span>
            </div>
            <div class="i-right">
              <img src="../../assets/icons/商机.png" alt="">
            </div>
          </div>
        </div>
        <div class="right-c">
          <div class="tops_right">
            <div class="mnb">
              <div class="title">合同KPI统计</div>
              <el-date-picker style="width: 150px" v-model="value4" type="month" placeholder="选择年月"
                @blur="aaa()"></el-date-picker>
            </div>
            <div class="left_curr">
              <div id="sales-kpi-chart" :style="{ width: '25rem', height: '26rem' }"></div>
              <div class="sales-kpi-text">
                <div class="completed">
                  <span class="icon"></span>
                  <span class="name">已完成</span>
                  <span class="value">{{ rate }}</span>
                  <span></span>
                </div>
                <div class="undone">
                  <span class="icon"></span>
                  <span class="name">未完成</span>
                  <span class="value">{{ 100 - rate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="tops_right">
            <div class="mnb">
              <div class="title">回款KPI统计</div>
              <el-date-picker style="width: 150px" v-model="value2" type="month" placeholder="选择年月"
                @blur="aa()"></el-date-picker>
            </div>
            <div class="left_curr">
              <div id="payback-kpi-chart" :style="{ width: '25rem', height: '26rem' }"></div>
              <div class="sales-kpi-text">
                <div class="completed">
                  <span class="icon"></span>
                  <span class="name">已完成</span>
                  <span class="value">{{ reat }}</span>
                  <span></span>
                </div>
                <div class="undone">
                  <span class="icon"></span>
                  <span class="name">未完成</span>
                  <span class="value">{{ 100 - reat }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-d">
          <div class="d-top">
            <div class="title">消息公告</div>
            <div class="knowM" @click="onMore">了解更多</div>
          </div>
          <div class="topsees">
            <!-- <div class="nav" @click="onMore">
              <el-input placeholder="输入您想查找的关键词" v-model="input4">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div> -->
            <div class="nvebd" v-for="(item, index) in list" :key="index" @click="ssone(item.id)">
              <div class="cover" v-if="item.cover">
                <el-image class="n-img" :src="item.cover" fit="fill"></el-image>
              </div>
              <div class="r-content">
                <div>{{ item.title }}</div>
                <div class="r-d">
                  <span class="addtime">{{ item.addtime }}</span>
                  <span class="look" @click="ssone(item.id)">查看详情</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <router-view v-else></router-view>
</template>

<script>
import { mapGetters } from "vuex";
import qs from "qs";
export default {
  name: "workbench",
  computed: {
    ...mapGetters(["name"]),
    isWorkbench() {
      return this.$route.name === "workbench";
    },
    widthT() {
      if (this.$store.state.user.userInfo.type == 1) {
        return '47.5%';
      } else {
        if (this.$store.state.app.sidebar.opened) {
          return '49.5%'
        } else {
          return '48%'
        }
      }
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
  },
  data() {
    return {
      crm: {},
      options: [
        {
          value: "year",
          label: "本年",
        },
        {
          value: "lastYear",
          label: "去年",
        },
        {
          value: "quarter",
          label: "本季度",
        },
        {
          value: "lastQuarter",
          label: "上季度",
        },
        {
          value: "month",
          label: "本月",
        },
        {
          value: "lastMonth",
          label: "上月",
        },
        {
          value: "week",
          label: "本周",
        },
        {
          value: "lastWeek",
          label: "上周",
        },
        {
          value: "tody",
          label: "今天",
        },
        {
          value: "yesterday",
          label: "昨天",
        },
      ],
      value: "month",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      year: "",
      years: "",
      mm: "",
      mms: "",
      timeNow: "",
      currentRate: 0,
      currentRates: 0,
      contractPercent: 0,
      receivablesPercent: 0,
      rate: 0,
      reat: 0,
      a: "0",
      b: "0",
      pkpi: {},
      list: {},
      tooken: [],
      Allhonor: [],
      loginType: "everydayadd",
      types: 1,
      start_time: "",
      end_time: "",
      noticetext: {},
      nmoe: 1,
      PriveCount: {},
      input4: "",
      shopKpi: "",
      returnKpi: "",
      newAdd: {},  //新增数据
    };
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  mounted() {
    if (window.localStorage.getItem("crm")) {
      let crm = JSON.parse(window.localStorage.getItem("crm"));
      this.crm = crm;
    }
    // this.notice();
    this.drawLine();
    this.money();
    this.moneys();
    this.announcement();
    this.honor();
    this.getAccountPriveCount();
  },
  watch: {
    value() {
      this.drawLine();
    },

  },
  methods: {
    getAccountPriveCount() {
      this.axios
        .post(
          "/crm/Mymine/getAccountPriveCount",
          qs.stringify({
            account_id: this.crm.account_id,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "token无效") {
            this.$router.push("/register");
          }
          this.PriveCount = res.data;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    notice() {
      this.axios
        .post(
          "/crm/UserAccount/getNotice",
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (!localStorage.getItem("isAlertNotice")) {
            this.noticetext = res.data;
            const href = location.href;
            this.$notify({
              title: this.noticetext.title,
              dangerouslyUseHTMLString: true,
              message: `<strong class="abduse">${this.noticetext.content}</strong><div class="abdue"><p class="ashijian">${this.noticetext.addtime}</p><a class="abdusea" href="${href}/notice">查看 >></a></div>`,
              position: "bottom-right",
            });
            localStorage.setItem("isAlertNotice", true);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    bod() {
      if (this.value1 == null) {
        this.start_time = "";
        this.end_time = "";
        this.honor();
      } else {
        let a = this.value1[0].valueOf();
        let b = this.value1[1].valueOf();

        this.start_time = a / 1000;
        this.end_time = b / 1000;
        this.honor();
      }
    },
    everyday() {
      this.loginType = "everydayadd";
      this.types = 1;
      this.honor();
    },
    communicate() {
      this.loginType = "communicateadd";
      this.types = 2;
      this.honor();
    },
    sign() {
      this.loginType = "signadd";
      this.types = 3;
      this.honor();
    },
    honor() {
      this.axios
        .post(
          "/crm/Achievement/honorTotal",
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            start_time: this.start_time,
            end_time: this.end_time,
            type: "tody",
            types: this.types,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          this.Allhonor = res.data;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    ssone(id) {
      this.$router.push({
        name: "workbenchDetail",
        query: {
          id,
        },
      });
    },
    onMore() {
      this.$router.push({
        name: "news",
      });
    },
    announcement() {
      this.axios
        .post(
          "/crm/Mymine/lookNotice",
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          this.list = res.data.slice(0, 2);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    text() {
      return this.currentRate.toFixed(0) + "%";
    },
    aa() {
      this.year = this.value2.getFullYear();
      let MM = this.value2.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      this.mm = MM;
      this.money();
    },
    aaa() {
      console.log(this.value4, '44')
      this.year = this.value4.getFullYear();
      let MM = this.value4.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      this.mm = MM;
      this.moneys();
    },
    drawLine() {
      this.axios
        .post(
          "/crm/Achievement/index",
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            search_type: "1",
            type: this.value,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          this.newAdd = res.data;
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 合同kpi
    moneys() {
      this.axios
        .post(
          "/crm/Achievement/getKpi",
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            search_type: "1",
            year: this.years,
            month: this.mms,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (this.value3 == "") {
            this.value3 = res.data.timeNowPc;
          }
          this.pkpi = res.data;
          if (this.pkpi.contractPercent > 100) {
            this.rate = 100
          } else {
            this.rate = this.pkpi.contractPercent
          }
          if (this.pkpi.receivablesPercent > 100) {
            this.reat = 100
          } else {
            this.reat = this.pkpi.receivablesPercent
          }
          if (this.pkpi.contractPercent == 0) {
            this.a = "0%";
          } else {
            this.a = this.pkpi.contractPercent + "%";
          }
          if (this.pkpi.receivablesPercent == 0) {
            this.b = "0%";
          } else {
            this.b = this.pkpi.receivablesPercent + "%";
          }
          this.receivablesPercent = Number(this.pkpi.receivablesPercent);
          this.showPicker = false;

          let data = res.data.contractPercent;
          if (data > 100) {
            this.shopKpi = 100
          } else {
            this.shopKpi = data
          }
          let myChart = this.$echarts.init(
            document.getElementById("sales-kpi-chart")
          );
          window.addEventListener("resize", function () {
            myChart.resize();
          });
          myChart.setOption({
            backgroundColor: "#fff",
            title: {
              text: '{a|' + this.shopKpi + '}{c|%}',
              x: 'center',
              y: 'center',
              textStyle: {
                rich: {
                  a: {
                    fontSize: 24,
                    color: '#49B372',
                    fontWeight: 'normal'
                  },
                  c: {
                    fontSize: 24,
                    color: '#49B372',
                    fontWeight: 'normal'
                  }
                }
              }
            },
            legend: {
              left: 'left'
            },
            series: [
              //外环
              {
                name: "外环",
                type: 'pie',
                silent: true,
                clockwise: true,
                radius: ['70%', '75%'],
                label: {
                  show: false,
                },
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: '#F0FFF6',
                },
                data: [0]
              },
              //内环
              {
                name: "内环",
                type: 'pie',
                silent: true,
                clockwise: true,
                radius: ['45%', '46%'],
                label: {
                  show: false,
                },
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: '#F0FFF6',
                },
                data: [0]
              },
              //外环
              {
                name: '',
                type: 'pie',
                radius: ['55%', '65%'],
                silent: true,
                clockwise: true,
                startAngle: 90,
                label: {
                  show: false,
                },
                data: [
                  {
                    value: this.shopKpi,
                    itemStyle: {
                      normal: {
                        //外环发光
                        borderWidth: 0.5,
                        shadowBlur: 20,
                        borderColor: '#F0FFF6',
                        shadowColor: '#9bfeff',
                        color: { // 圆环的颜色
                          colorStops: [{
                            offset: 0,
                            color: '#49B372', // 0% 处的颜色
                          }, {
                            offset: 1,
                            color: '#49B372', // 100% 处的颜色
                          }]
                        },
                      }
                    }
                  },
                  {
                    value: 100 - this.shopKpi,
                    label: {
                      normal: {
                        show: false
                      }
                    },
                    itemStyle: {
                      normal: {
                        color: "#BBF4D2"
                      }
                    }
                  }
                ]
              },
            ]
          });
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    // 回款kpi
    money() {
      this.axios
        .post(
          "/crm/Achievement/getKpi",
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            search_type: "1",
            year: this.year,
            month: this.mm,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (this.value2 == "") {
            this.value2 = res.data.timeNowPc;
          }
          this.pkpi = res.data;
          if (this.pkpi.contractPercent > 100) {
            this.rate = 100
          } else {
            this.rate = this.pkpi.contractPercent
          }
          if (this.pkpi.receivablesPercent > 100) {
            this.reat = 100
          } else {
            this.reat = this.pkpi.receivablesPercent
          }
          if (this.pkpi.contractPercent == 0) {
            this.a = "0%";
          } else {
            this.a = this.pkpi.contractPercent + "%";
          }
          if (this.pkpi.receivablesPercent == 0) {
            this.b = "0%";
          } else {
            this.b = this.pkpi.receivablesPercent + "%";
          }
          this.contractPercent = Number(this.pkpi.contractPercent);
          this.showPicker = false;

          let data = res.data.receivablesPercent;
          if (data > 100) {
            this.returnKpi = 100
          } else {
            this.returnKpi = data
          }
          let myChart = this.$echarts.init(
            document.getElementById("payback-kpi-chart")
          );
          window.addEventListener("resize", function () {
            myChart.resize();
          });
          myChart.setOption({
            backgroundColor: "#fff",
            title: {
              text: '{a|' + this.returnKpi + '}{c|%}',
              x: 'center',
              y: 'center',
              textStyle: {
                rich: {
                  a: {
                    fontSize: 24,
                    color: '#49B372',
                    fontWeight: 'normal'
                  },
                  c: {
                    fontSize: 24,
                    color: '#49B372',
                    fontWeight: 'normal'
                  }
                }
              }
            },
            series: [
              //外环
              {
                name: "外环",
                type: 'pie',
                silent: true,
                clockwise: true,
                radius: ['70%', '75%'],
                label: {
                  show: false,
                },
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: '#F0FFF6',
                },
                data: [0]
              },
              //内环
              {
                name: "内环",
                type: 'pie',
                silent: true,
                clockwise: true,
                radius: ['45%', '46%'],
                label: {
                  show: false,
                },
                labelLine: {
                  show: false
                },
                itemStyle: {
                  color: '#F0FFF6',
                },
                data: [0]
              },
              //外环
              {
                name: '',
                type: 'pie',
                radius: ['55%', '65%'],
                silent: true,
                clockwise: true,
                startAngle: 90,
                label: {
                  show: false,
                },
                data: [
                  {
                    value: this.returnKpi,
                    itemStyle: {
                      normal: {
                        //外环发光
                        borderWidth: 0.5,
                        shadowBlur: 20,
                        borderColor: '#F0FFF6',
                        shadowColor: '#9bfeff',
                        color: { // 圆环的颜色
                          colorStops: [{
                            offset: 0,
                            color: '#49B372', // 0% 处的颜色
                          }, {
                            offset: 1,
                            color: '#49B372', // 100% 处的颜色
                          }]
                        },
                      }
                    }
                  },
                  {
                    value: 100 - this.returnKpi,
                    label: {
                      normal: {
                        show: false
                      }
                    },
                    itemStyle: {
                      normal: {
                        color: "#BBF4D2"
                      }
                    }
                  }
                ]
              },
            ]
          });
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.el-notification {
  border-radius: 0px !important;
  /* border: 1px solid black !important; */
  box-shadow: none !important;
  padding: 0px;
}

.el-notification__group {
  width: 100%;
  /* background-color: red; */
  margin: 0;
}

.el-notification__title {
  width: 100%;
  padding: 13px 5px;
  background-color: rgb(242, 242, 242);
  border: 1px solid #dcdcdc;
}

.el-notification__content {
  padding: 10px;
  margin: 0;
}

.el-icon-date:before {
  color: #49B372;
}

.abdue {
  border-top: 1px dashed #dcdcdc;
  padding: 10px;
}

.abduse {
  padding: 10px;
  position: relative;
}

.abdusea {
  float: right;
  position: absolute;
  right: 20px;
  bottom: 5px;
  color: #1caaea;
}

.abdusea:hover {
  color: #1caaea;
}

.ashijian {
  position: absolute;
  left: 30px;
  bottom: 5px;
}
</style>
<style lang="scss" scoped>
.dashboard-container {
  height: 100%;
  width: 100%;
}

.title {
  font-weight: 500;
  font-size: 2.4rem;
  color: #333;
  line-height: 3.3rem;
}

.xiao-nav {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;

  .xiao-title {
    font-size: 2.4rem;
    font-weight: 500;
    color: #333333;
    line-height: 3.3rem;
  }
}

.outside {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.xiao-left {
  // width: 49.5%;

  .left-t {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .left-d {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 3px 3px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0.8rem;
    padding: 2rem 0;
  }
}

.top-item {
  width: 40rem;
  display: flex;
  justify-content: space-between;
  padding: 4rem 3rem;
  background: #fff;
  margin-bottom: 2rem;
  box-shadow: 3px 3px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 0.8rem;
  border: 1px solid #F6F6F6;

  .i-left {
    display: flex;
    flex-direction: column;

    span:first-child {
      font-size: 2.1rem;
      font-weight: 400;
      color: #666666;
      line-height: 2.9rem;
      margin: 0 0 2rem 0;
    }

    span:last-child {
      font-size: 4.8rem;
      font-weight: bold;
      color: #333333;
      line-height: 5.6rem;
    }
  }

  .i-right {
    img {
      width: 6rem;
      height: 6rem;
    }
  }
}

.xiao-right {
  // width: 49.5%;

  .right-t {
    display: flex;
    justify-content: space-between;
  }

  .right-c {
    width: 100%;
    padding: 2rem 2rem 3.7rem 2rem;
    background: #fff;
    border-radius: 0.8rem;
    display: flex;
    justify-content: space-between;
    box-shadow: 3px 3px 20px 0px rgba(0, 0, 0, 0.1);
  }

  .right-d {
    padding: 2rem 2rem 3rem 2rem;
    background: #fff;
    border-radius: 0.8rem;
    margin-top: 2rem;
    box-shadow: 3px 3px 20px 0px rgba(0, 0, 0, 0.1);

    .d-top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .knowM {
        color: #fff;
        padding: 1rem 1.2rem;
        font-size: 1.4rem;
        line-height: 2rem;
        background: #49B372;
        border-radius: 0.8rem;
      }
    }

    .topsees {
      .nvebd {
        display: flex;
        margin-top: 3rem;

        .cover {
          .n-img {
            width: 18rem;
            height: 10rem;
            margin-right: 2rem;
          }
        }

        .r-content {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          div:first-child {
            font-size: 1.8rem;
            font-weight: 500;
            color: #333333;
            line-height: 2.5rem;
          }

          .r-d {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .addtime {
              font-size: 1.4rem;
              font-weight: 400;
              color: #FFAB2B;
              line-height: 2rem;
            }

            .look {
              font-size: 1.2rem;
              font-weight: 400;
              color: #49B372;
              line-height: 1.7rem;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

.left_curr {
  display: flex;
  align-items: center;
}

.mnb,
.honer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.honer {
  padding: 0 2rem 2rem 2rem;
  border-bottom: 1px solid #F2F2F2;
  margin-bottom: 2rem;
}

.body_nav {
  padding: 0 2rem;
  display: flex;
}

.body_nav>span {
  color: #aaa;
  font-size: 1.4rem;
  padding: 1.3rem 1.4rem;
  text-align: center;
  cursor: pointer;
  border-radius: 0.8rem;
  border: 1px solid #E6E6E6;
  margin-right: 1rem;
}

.body_nav .hoverennd {
  background: #49B372 linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(77, 181, 117, 0) 100%);
  color: #fff;
}

.body_body {
  padding: 3rem 2rem 2.5rem;
  display: flex;
  flex-direction: column;
}

.bodynone:nth-child(2n-1) {
  background: #F6FFFA;
}

.bodynone {
  .b-i {
    padding: 3.4rem 2rem 3.5rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      align-items: center;

      .icon_img {
        width: 2rem;
        height: 2.7rem;
        margin-right: 1.5rem;
      }

      .avatar {
        width: 4rem;
        height: 4rem;
        margin-right: 1rem;
      }
    }

    span {
      display: flex;
      align-items: center;
      font-size: 1.2rem;
      font-weight: 400;
      color: #333333;
    }
  }
}

// 销售kpi统计图

.sales-kpi-text {
  width: 12rem;
}

.name {
  font-size: 1.4rem;
  font-weight: 400;
  color: #999999;
  line-height: 2rem;
  margin: 0 1.5rem 0 1rem;
}

.value {
  font-size: 2.4rem;
  font-weight: bold;
  color: #333333;
  line-height: 2.8rem;
}

.completed {
  display: flex;
  align-items: center;
  margin-bottom: 2.8rem;

  .icon {
    width: 1rem;
    height: 1rem;
    background: #49B372;
    border-radius: 0.2rem;
  }
}

.undone {
  display: flex;
  align-items: center;

  .icon {
    width: 1rem;
    height: 1rem;
    background: #BBF4D2;
    border-radius: 0.2rem;
  }
}
</style>